<template>
	<div style="padding: 10px;">
		<el-row :gutter="20">
			<el-col :span="5"> 
				<el-input clearable placeholder="请输入菜品名称" v-model="searchInfo.foodname">
					<template slot="prepend">菜品名称</template>
				</el-input>
			</el-col>
			<el-col :span="5">
				<el-select clearable style="width: 100%;" v-model="searchInfo.stallid" filterable placeholder="请选择档口">
				    <el-option v-for="item in stallList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
				</el-select>
			</el-col>
			<el-col :span="5">
				<el-select clearable style="width: 100%;" v-model="searchInfo.foodcategory" filterable placeholder="菜品分类">
				    <el-option v-for="item in categoryList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
				</el-select>
			</el-col>
			<el-col :span="9"> 
				  <el-button type="primary" @click="searchFoods" icon="el-icon-search">搜索</el-button>
				  <el-button  icon="el-icon-refresh" @click="clearSearch">重置</el-button>
				  <el-button type="primary" icon="el-icon-plus" @click="addFoods">新增</el-button>
			</el-col>
		</el-row>
		<div style="margin-top: 10px;">
			<el-table :data="foodsList"  style="width: 100%"  height="700">
			    <el-table-column fixed="left" prop="name" label="菜品名称" width="150" align="center"></el-table-column>
			    <el-table-column prop="price" label="价格" width="120" align="center"></el-table-column>
			    <el-table-column prop="packfee" label="打包费"  width="120" align="center"></el-table-column>
			    <el-table-column prop="maxsale" label="每日最大售卖" width="150" align="center"></el-table-column>
			    <el-table-column prop="businessname" label="所属商家" align="center"></el-table-column>
			    <el-table-column prop="stallname" label="所属档口" align="center"></el-table-column>
				<el-table-column prop="uptime" label="上架时间" align="center"></el-table-column>
				<el-table-column prop="statename" label="状态" align="center"></el-table-column>
				<el-table-column prop="pic" label="图片" width="120" align="center">
					<template slot-scope="scope">
						<el-image style="width: 60px; height: 60px;border-radius: 10px;" :src="scope.row.pic" ></el-image>
					</template>
				</el-table-column>
				<el-table-column fixed="right" prop="op" label="操作" width="220" align="center">
					<template slot-scope="scope">
						<a @click="goFoodDetail(scope.$index, scope.row)" title="菜品详情" style="display:inline-block;cursor:pointer;color: #409EFF;">
							<i class="el-icon-food">详情</i>
						</a>
						<a v-show="scope.row.state == 'up'" @click="putDownFood(scope.$index, scope.row)" title="下架菜品" style="cursor:pointer;margin-left: 10px;color: #E6A23C;">
							<i class="el-icon-bottom">下架</i>
						</a>
						<a v-show="scope.row.state == 'down'" @click="putUpFood(scope.$index, scope.row)" title="上架菜品" style="cursor:pointer;margin-left: 10px;color: #67C23A;">
							<i class="el-icon-top">上架</i>
						</a>
						<a v-show="scope.row.state == 'down'" @click="deleteFoods(scope.$index, scope.row)" title="删除菜品" style="cursor:pointer;margin-left: 10px;color: #F56C6C;">
							<i class="el-icon-delete">删除</i>
						</a>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div style="text-align: center;">
			<el-pagination background layout="total, prev, pager, next, sizes" :page-sizes="[10, 20, 50]" :current-page="param.page"
				:page-size="param.pagenum" :total="foodsTotal" @size-change="handleSizeChange" @current-change="handleCurrentChange"> </el-pagination>
		</div>
		<el-dialog @close="refrashData" :destroy-on-close="false" :title="detailTitle" width="70%" :visible.sync="fooddetailShow">
			<FoodsDetail @needRefrash="needRefrash" :fid="selectfoodid" :category="categoryList" :stalls="stallList"></FoodsDetail>
		</el-dialog>
	</div>
</template>

<script>
	import {nfsprefix , baseUrl } from '/static/baseUrl.js'
	import {queryFoodCategroy, queryFoodLists,putToSaleFood,putDownFood, deleteFood } from '/static/apiUrl.js'
	import FoodsDetail from './fooddetail'
	export default {
		name : 'FoodsList',
		data() {
			return {
				fooddetailShow : false,
				editok : false,
				detailTitle : '菜品详情',
				selectfoodid : '',
				searchInfo:{
					foodname : '',
					stallid : '',
					foodcategory : '',
				},
				param : {
					page : 1,
					pagenum : 10,
				},
				stallList : [
					{
						label : '档口1',
						value : '档口1',
					},
					{
						label : '档口2',
						value : '档口2',
					},
				],
				categoryList : [],
				foodsTotal : 0,
				foodsList : [
					/* {
						name : '菜品1',
						price : 9.00,
						packfee : 1,
						maxsale : 50,
						businessname : '商家1',
						stallname : '档口1',
						uptime : '2024-10-01 12:00:00',
						state : '售卖中',
						pic : baseUrl + nfsprefix + '/foods2.png',
					},
					{
						name : '菜品1',
						price : 9.00,
						packfee : 1,
						maxsale : 50,
						businessname : '商家1',
						stallname : '档口1',
						uptime : '2024-10-01 12:00:00',
						state : '售卖中',
						pic : baseUrl + nfsprefix + '/foods3.png',
					} */
				],
				
			}
		},
		mounted() {
			this.initData()
			this.queryFoods()
		},
		components: {
			FoodsDetail
		},
		methods: {
			handleSizeChange(val){
				console.log(val);
				this.param.pagenum = val;
				this.queryFoods()
			},
			handleCurrentChange(val){
				console.log(val);
				this.param.page = val
				this.queryFoods()
			},
			putDownFood(idx, row){
				console.log(idx,row)
				this.$confirm('确定将 '+row.name+' 下架?', '菜品下架', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let fids = [row.id]
					putDownFood({
						foodids : fids
					}).then(res => {
						console.log(res)
						if(0 == res.code){
							row.statename = '未上架'
							row.state = 'down'
							this.$message({
								type: 'success',
								message: '下架成功!'
							});
						}else{
							this.$message({
								type: 'error',
								message: res.msg
							});
						}
					})
				}).catch((err) => {
					console.log(err)
				});
			},
			putUpFood(idx, row){
				console.log(idx,row)
				this.$confirm('确定将 '+row.name+' 上架销售?', '菜品上架', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let fids = [row.id]
					putToSaleFood({
						foodids : fids
					}).then(res => {
						console.log(res)
						if(0 == res.code){
							row.statename = '在售中'
							row.state = 'up'
							this.$message({
								type: 'success',
								message: '上架成功!'
							});
						}else{
							this.$message({
								type: 'error',
								message: res.msg
							});
						}
					})
				}).catch((err) => {
					console.log(err)
				});
			},
			deleteFoods(idx,row){
				console.log(idx,row)
				this.$confirm('确定将 '+row.name+' 删除?', '菜品删除', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let fids = [row.id]
					deleteFood({
						ids : fids
					}).then(res => {
						console.log(res)
						if(0 == res.code){
							this.foodsList.splice(idx,1)
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
						}else{
							this.$message({
								type: 'error',
								message: res.msg
							});
						}
					})
				}).catch((err) => {
					console.log(err)
				});
			},
			initData(){
				queryFoodCategroy().then(res => {
					console.log(res)
					if(0 == res.code){
						this.categoryList = res.data.data
					}
				})
			},
			searchFoods(){
				this.param.page = 1
				this.foodsList = []
				this.queryFoods()
			},
			clearSearch(){
				this.searchInfo.foodcategory = '';
				this.searchInfo.foodname = ''
				this.searchInfo.stallid = ''
				this.param.page = 1
				this.queryFoods()
			},
			queryFoods(){
				this.foodsList = []
				queryFoodLists({
					stall_id : this.searchInfo.stallid,
					name : this.searchInfo.foodname,
					categoryid : this.searchInfo.foodcategory,
					offset : (this.param.page - 1) * this.param.pagenum,
					limit : this.param.pagenum
				}).then(res => {
					console.log(res)
					if(0 == res.code){
						this.foodsTotal = res.data.total
						res.data.data.forEach((food ) => {
							this.foodsList.push({
								id : food.foods_id,
								name : food.foods_name,
								price : food.foods_platformprice,
								packfee : food.foods_packprice,
								maxsale : food.foods_perdaymax,
								businessname : food.service_businessname,
								stallname : food.service_stallname,
								uptime : '',  //接口未返回
								state : food.foods_state ,
								statename : food.foods_state == 'up' ? '在售中' : '未上架',
								pic : baseUrl + nfsprefix + '',  // 接口未返回
							})
						})
					}
				})
			},
			goFoodDetail(idx,row){
				this.detailTitle = '菜品详情'
				console.log(idx,row)
				this.selectfoodid = row.id
				this.fooddetailShow = true
			},
			addFoods(){
				this.detailTitle = "新增菜品"
				this.selectfoodid = ''
				this.fooddetailShow = true
			},
			needRefrash(val){
				console.log(val)
				this.editok = val
			},
			refrashData(){
				console.log('ddd')
				if(this.editok){
					this.queryFoods()
				}
			}
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>